var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94 188",
    style: {
      enableBackground: "new 0 0 94 188"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;}\n\t.st1{clip-path:url(#SVGID_2_);fill:none;stroke:#04E6D4;stroke-width:4;stroke-miterlimit:10;stroke-dasharray:6.818,11.971;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#04E6D4;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.3,
    y: 0.2,
    width: 94.4,
    height: 188.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.5,2c0,0,104.8,45.8,76.4,183.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.3,163.8c0.7-0.3,1.5,0.1,1.8,0.8l7.9,19.9L91.7,169c0.5-0.6,1.4-0.6,2-0.1c0.6,0.5,0.6,1.4,0.1,2 L77.5,188c-0.3,0.3-0.8,0.5-1.3,0.4c-0.5-0.1-0.9-0.4-1-0.9l-8.7-22c-0.1-0.3-0.1-0.5-0.1-0.8C66.6,164.4,66.9,164,67.3,163.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDx);
export default __webpack_public_path__ + "static/media/arrow-dx.f63119673dca5e668a9dd54c2d4576a4.svg";
export { ForwardRef as ReactComponent };